import { SVGProps, Ref, forwardRef } from 'react';

export const LivejournalBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M8.441 1.9c-.924 0-1.802.192-2.604.54L4.397 1A6.58 6.58 0 0 0 1 4.413l1.44 1.44a6.5 6.5 0 0 0-.549 2.602 6.55 6.55 0 0 0 4.05 6.048 6.56 6.56 0 0 0 7.143-1.424A6.549 6.549 0 0 0 8.44 1.9"
                fill="#00B0EA"
            />
            <path
                d="M11.172 7.761a6.58 6.58 0 0 0-3.397 3.413L2.44 5.853a6.57 6.57 0 0 1 3.402-3.414z"
                fill="#15374C"
            />
            <path d="M9.581 11.559a3.83 3.83 0 0 1 1.97-1.984l.517 2.5z" fill="#15374C" />
            <path
                d="m11.552 9.58-.38-1.82a6.58 6.58 0 0 0-3.397 3.414l1.801.385a3.85 3.85 0 0 1 1.97-1.984"
                fill="white"
            />
        </g>
    </svg>
));
LivejournalBrandSize16Glyph.displayName = 'LivejournalBrandSize16Glyph';
